import axios from 'axios'
import { get } from 'lodash'

if (!window.axios) {
  window.axios = axios
  window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
  window.axios.defaults.withCredentials = true;

  // Set Authorization header from localStorage token on app load
  const token = localStorage.getItem('freshability trace track')
  if (token) {
    window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
  }

  window.axios.interceptors.response.use(function (response) {
      return response;
  }, function (error) {
      if (401 === get(error, 'response.status')) {
        window.location.assign('/login')
          // handle error: inform user, go to login, etc
      } else if (403 === get(error, 'response.status')) {
        // Trigger unauthorized modal
        if (window.modalStore) {
          window.modalStore.openErrorModal('unauthorized')
        }
        return Promise.reject(error);
      } else if (500 === get(error, 'response.status')) {
        // Trigger server error modal
        if (window.modalStore) {
          window.modalStore.openErrorModal('server')
        }
        return Promise.reject(error);
      } else {
          return Promise.reject(error);
      }
  });
}

if (!window.isDesktopWidth) {
  window.isDesktopWidth = () => {
    return window.screen.width >= 1024
  }
}


if (!window.cpyObj) {
  window.cpyObj = (obj, defaultVal = {}) => {
    if (typeof obj === 'undefined') {
      return defaultVal
    }

    return JSON.parse(JSON.stringify(obj));
  }
}

if (!window.setTitle) {
  window.setTitle = (title) => {
    document.title = title + ' - Freshability'
  }
}

if (!document.title) {
  document.title = 'Freshability'
}

if (!window.guid) {
  window.guid = (length = 8) => {
    let str = ''
    for (let i = 1; i <= length; i++) {
      if (i === 8) {
        str+= '-'
      }

      str+= 'x'
    }

    return str.replace(/[xy]/g, function(c) {
      var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
      return v.toString(16);
    });
  }
}

if (!window.isGuid) {
  window.isGuid = (val) => {
    if (typeof val === 'number') {
      return false
    }

    return (val.match(/[a-zA-Z]+/)) ? true : false
  }
}

if (!window.isIterable) {
  window.isIterable = (obj) => {
    // checks for null and undefined
    if (obj == null) {
      return false;
    }

    return typeof obj[Symbol.iterator] === 'function';
  }
}

import '../../css/app.css';
import '../../images/favicon.ico';
